import { GetContactActivitiesQuery, useGetContactActivitiesQuery } from "generated/graphql";
import { useMemo } from "react";

export type ProposalActivityRow = NonNullable<GetContactActivitiesQuery["getContactActivities"]>["data"][number];

type UseProposalActivitiesArgs = {
  contactId?: string | null;
  opportunityId?: string | null;
  first?: number;
  page?: number;
};

export const useProposalActivities = ({
  contactId,
  opportunityId,
  first = 50,
  page = 1,
}: UseProposalActivitiesArgs) => {
  const { data, loading, error } = useGetContactActivitiesQuery({
    variables: {
      contactId: contactId ?? "",
      opportunityId: opportunityId ?? undefined,
      first,
      page,
    },
    skip: !contactId,
    fetchPolicy: "cache-and-network",
  });

  const activities = useMemo(() => data?.getContactActivities?.data ?? [], [data]);

  return { activities, loading, error } as const;
};
